import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// Location tracking removed - not used in production

export const getCurrentLocation = createAsyncThunk(
  "location/get",
  async (_, { rejectWithValue }) => {
    // Location tracking disabled - return null
    return null;
  }
);

export const locationSlice = createSlice({
  name: "location",
  initialState: {
    isLoading: false,
    error: null,
    location: null,
  },

  reducers: {
    resetLocation: () => ({
      location: null,
    }),
  },

  extraReducers: (builder) => {
    builder
      .addCase(getCurrentLocation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCurrentLocation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.location = action.payload;
      })
      .addCase(getCurrentLocation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetLocation } = locationSlice.actions;

export default locationSlice.reducer;
